import { roundQtyDownToStep } from "./futuresLeverageHelpers";

/** Classic futures form units — Amount (base) or Value (quote / margin asset). */
export function normalizeFuturesContractUnitId(id) {
    return id === "value_quote" ? "value_quote" : "amount_base";
}

export function denomFromFuturesContractUnitId(id) {
    return normalizeFuturesContractUnitId(id) === "value_quote" ? "QUOTE" : "BASE";
}

export function isFuturesValueUnit(id) {
    return normalizeFuturesContractUnitId(id) === "value_quote";
}

/** Whether the amount field is entered in quote / margin asset (e.g. USDT). */
export function resolveFuturesAmountIsQuote({
    orderType,
    isBuy,
    contractUnitId,
    buyAmountDenom,
    sellAmountDenom,
}) {
    if (["LIMIT", "MARKET", "CONDITIONAL"].includes(orderType)) {
        return isFuturesValueUnit(contractUnitId);
    }
    return isBuy ? buyAmountDenom === "QUOTE" : sellAmountDenom === "QUOTE";
}

/** Price used to convert a quote-denominated amount into base quantity. */
export function resolveFuturesPriceForQtyConversion({
    orderType,
    isBuy,
    markPrice,
    buyOrderPrice,
    sellOrderPrice,
    buyStopPrice,
    sellStopPrice,
    buyOrderAfterTrigger,
    sellOrderAfterTrigger,
    buyprice,
    sellPrice,
}) {
    const mark = Number(markPrice) || Number(buyprice) || Number(sellPrice) || 0;

    if (orderType === "LIMIT") {
        const rawPrice = isBuy ? buyOrderPrice : sellOrderPrice;
        const fallback = isBuy ? (Number(buyprice) || 0) : (Number(sellPrice) || 0);
        const parsed = String(rawPrice ?? "").trim() !== "" ? parseFloat(rawPrice) : fallback;
        return Number.isFinite(parsed) && parsed > 0 ? parsed : mark;
    }

    if (orderType === "CONDITIONAL") {
        const rawOrderPrice = isBuy ? buyOrderAfterTrigger : sellOrderAfterTrigger;
        if (rawOrderPrice && String(rawOrderPrice).trim() !== "") {
            const orderPx = parseFloat(rawOrderPrice);
            if (Number.isFinite(orderPx) && orderPx > 0) return orderPx;
        }
        const rawTrigger = isBuy ? buyStopPrice : sellStopPrice;
        const triggerVal = parseFloat(rawTrigger);
        if (Number.isFinite(triggerVal) && triggerVal > 0) return triggerVal;
        return mark;
    }

    return mark;
}

/** Convert UI amount to base quantity for API / validation. */
export function convertFuturesAmountToBaseQty({ rawAmount, isQuoteSize, priceForConversion, stepSize }) {
    const rawVal = parseFloat(String(rawAmount ?? "").replace(/,/g, ""));
    if (!Number.isFinite(rawVal) || rawVal <= 0) {
        return { rawVal: NaN, baseQty: NaN };
    }
    if (!isQuoteSize) {
        return { rawVal, baseQty: rawVal };
    }
    const px = Number(priceForConversion);
    if (!Number.isFinite(px) || px <= 0) {
        return { rawVal, baseQty: NaN };
    }
    const baseQty = roundQtyDownToStep(rawVal / px, stepSize);
    return { rawVal, baseQty };
}
